import { MenuItem, Select } from '@material-ui/core';
import { useMemo } from 'react';
import { useUnsafeTranslation } from '../../../../i18next';
import { printTz } from '../../../../services/time';

export const UserTimezoneHandlingPicker = ({
  value,
  onChange,
  userLabel,
  defaultTz
}: {
  value: boolean;
  onChange: (nextValue: boolean) => void;
  defaultTz: string;
  userLabel?: string;
}) => {
  const { t } = useUnsafeTranslation();
  const userLabelOrDefault = userLabel || t('participant');
  const options = useMemo(() => {
    return [
      {
        value: 'USER_BASED',
        label: t(`in {{ userLabel }}'s timezone`, {
          userLabel: userLabelOrDefault
        })
      },
      {
        value: 'DEFAULT_TZ',
        label: `${printTz(defaultTz)} (${t('default timezone')})`
      }
    ];
  }, [defaultTz, t, userLabelOrDefault]);

  return (
    <Select
      value={value ? 'USER_BASED' : 'DEFAULT_TZ'}
      onChange={(ev) => onChange(ev.target.value === 'USER_BASED')}
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value}>
          {o.label}
        </MenuItem>
      ))}
    </Select>
  );
};
